import styled from 'styled-components/macro';

export const ChartWrapper = styled('div')({
  marginBottom: '50px',
});
